import { render, staticRenderFns } from "./View.vue?vue&type=template&id=21d8e8e6&scoped=true&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"
import style0 from "./View.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./View.vue?vue&type=style&index=1&id=21d8e8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8e8e6",
  null
  
)

component.options.__file = "View.vue"
export default component.exports